import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Domains from "@/components/Domains";
import Methods from "@/components/Methods";
import Projects from "@/components/Projects";
import Lab from "@/components/Lab";
import Stats from "@/components/Stats";
import Partners from "@/components/Partners";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="relative">
      <Nav />
      <Hero />
      <Marquee />
      <About />
      <Domains />
      <Methods />
      <Stats />
      <Projects />
      <Lab />
      <Partners />
      <Contact />
      <Footer />
    </main>
  );
}
